import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, FlameIcon } from 'lucide-react';
export function UrgencyBanner() {
  const percentage = 80;
  return <section className="py-6 bg-gradient-to-br from-red-800 via-red-700 to-orange-700 relative overflow-hidden" data-id="element-202">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.06),transparent_60%)] pointer-events-none" data-id="element-203" />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} data-id="element-205">
          {/* Title */}
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-206">
            <FlameIcon className="w-5 h-5 text-yellow-300" data-id="element-207" />
            <h3 className="md:text-xl font-extrabold text-white uppercase tracking-wide text-[14px]" data-id="element-208">
              Promoción por tiempo limitado
            </h3>
            <FlameIcon className="w-5 h-5 text-yellow-300" data-id="element-209" />
          </div>

          {/* Progress section */}
          <div className="bg-black/20 rounded-xl px-4 py-3 mb-3" data-id="element-210">
            <div className="flex items-center justify-between mb-2" data-id="element-211">
              <div className="flex items-center gap-1.5" data-id="element-212">
                <AlertTriangleIcon className="w-4 h-4 text-yellow-300" data-id="element-213" />
                <span className="text-white font-semibold text-sm" data-id="element-214">
                  Cupos disponibles agotándose
                </span>
              </div>
              <span className="bg-yellow-400 text-yellow-900 text-xs font-extrabold px-2.5 py-1 rounded-full" data-id="element-215">
                {percentage}% tomados
              </span>
            </div>

            {/* Progress bar */}
            <div className="w-full h-3 bg-black/30 rounded-full overflow-hidden" data-id="element-216">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${percentage}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.2,
              ease: 'easeOut',
              delay: 0.3
            }} className="h-full rounded-full bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400" data-id="element-217" />
            </div>
          </div>

          {/* Subtitle */}
          <p className="text-center text-red-100/90 text-sm font-medium" data-id="element-218">
            Últimos cupos a precio promocional — una vez agotados, vuelve al
            precio original.
          </p>
        </motion.div>
      </div>
    </section>;
}